import {
	APPLICATION_TYPE_OPTIONS,
	EMAIL_OPTION,
	SAVED_RESULT_OPTION,
} from "../../data/applicationTypes";
import { usePumpSizing } from "../../context/PumpSizingContext";
import { Card } from "../shared/Card";
import { Divider } from "../shared/Divider";
import { TextField } from "../shared/TextField";

/** The three main pump application types that need the hazardous location question. */
const PUMP_TYPE_IDS = new Set(APPLICATION_TYPE_OPTIONS.map((o) => o.id));

export function StepApplicationType() {
	const {
		formData,
		savedResultId,
		setApplicationType,
		setHazardousLocation,
		setSavedResultId,
	} = usePumpSizing();

	const showHazardousQuestion =
		formData.applicationType !== null &&
		PUMP_TYPE_IDS.has(formData.applicationType);

	const isSavedResultSelected =
		formData.applicationType === SAVED_RESULT_OPTION.id;

	const selectSavedResult = () => {
		if (!isSavedResultSelected) {
			setApplicationType(SAVED_RESULT_OPTION.id);
		}
	};

	return (
		<fieldset
			className="pf-step pf-step--application-type pf-application-type"
			aria-labelledby="application-type-label"
		>
			<legend id="application-type-label" className="pf-sr-only">
				Application type
			</legend>
			<div className="pf-step__card-grid">
				{APPLICATION_TYPE_OPTIONS.map((option) => (
					<Card
						key={option.id}
						title={option.title}
						description={option.description}
						isActive={formData.applicationType === option.id}
						onClick={() => setApplicationType(option.id)}
					/>
				))}
			</div>

			{showHazardousQuestion ? (
				<fieldset
					className="pf-hazardous-location"
					aria-labelledby="hazardous-location-label"
				>
					<legend
						id="hazardous-location-label"
						className="pf-hazardous-location__label"
					>
						Will this pump be used in a hazardous location?
					</legend>
					<div className="pf-hazardous-location__options">
						<label className="pf-hazardous-location__btn">
							<input
								type="radio"
								name="hazardousLocation"
								value="yes"
								checked={formData.hazardousLocation === true}
								onChange={() => setHazardousLocation(true)}
							/>
							Yes
						</label>
						<label className="pf-hazardous-location__btn">
							<input
								type="radio"
								name="hazardousLocation"
								value="no"
								checked={formData.hazardousLocation === false}
								onChange={() => setHazardousLocation(false)}
							/>
							No
						</label>
					</div>
				</fieldset>
			) : null}

			<Divider />

			<div className="pf-step__card-grid pf-step__card-grid--two">
				<Card
					title={EMAIL_OPTION.title}
					description={EMAIL_OPTION.description}
					isActive={formData.applicationType === EMAIL_OPTION.id}
					onClick={() => setApplicationType(EMAIL_OPTION.id)}
				/>

				<div
					className={`pf-saved-result${isSavedResultSelected ? " pf-saved-result--active" : ""}`}
				>
					<Card
						title={SAVED_RESULT_OPTION.title}
						description={SAVED_RESULT_OPTION.description}
						isActive={isSavedResultSelected}
						onClick={() => setApplicationType(SAVED_RESULT_OPTION.id)}
					/>
					<TextField
						label="Saved Result ID"
						className="pf-field-group--full pf-card__field"
						value={savedResultId}
						placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
						onChange={(event) => {
							selectSavedResult();
							setSavedResultId(event.target.value);
						}}
						onFocus={selectSavedResult}
						autoComplete="off"
						spellCheck={false}
					/>
				</div>
			</div>
		</fieldset>
	);
}
